import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { PushnotificationService } from 'src/app/services/pushnotification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AuthService,
      public router: Router,
      private pushNotificationService: PushnotificationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(catchError(err => {
            if ([401, 403].includes(err.status)) {
                // auto logout if 401 or 403 response returned from api
                this.accountService.logout();
                this.pushNotificationService.desregister();
                this.router.navigate(['/login']);
            }

           // const error = err.error?.message || err.statusText;
            return throwError(err);
           // return throwError(() => error);
        }));
    }
}
